import { render, staticRenderFns } from "./NewCourseCreated.vue?vue&type=template&id=64608840"
import script from "./NewCourseCreated.vue?vue&type=script&lang=js"
export * from "./NewCourseCreated.vue?vue&type=script&lang=js"
import style0 from "./NewCourseCreated.vue?vue&type=style&index=0&id=64608840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports